import { ACTION_CATEGORY_SELECTED } from './types'

const selectCategory = ({ rest }, index) => ({
    payload: { index: index >= 0 ? index : 0 },
    type: ACTION_CATEGORY_SELECTED,
})

export default selectCategory
